var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModeComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 20.0318L21.9684 18.6668H4.66671V4.66683H23.3334V20.0318ZM23.3334 2.3335H4.66671C3.38337 2.3335 2.33337 3.3835 2.33337 4.66683V18.6668C2.33337 19.9502 3.38337 21.0002 4.66671 21.0002H21L25.6667 25.6668V4.66683C25.6667 3.3835 24.6167 2.3335 23.3334 2.3335Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModeComment);
export default __webpack_public_path__ + "static/media/icon_mode_comment.11cd773563066406a94f3dcb69cd63a6.svg";
export { ForwardRef as ReactComponent };